import { httpClient } from "./httpClient";

const getAllEmployeeShift = () => {
  return httpClient.get("employeeShifts");
};

export default {
  getAllEmployeeShift,
};
